const billeteras = {
    "com.yacare.test": "Yacaré",
    "ar.com.santander": "Santander Río",
    "com.mercadolibre": "Mercado Pago",
    "ar.com.bna": "BNA+",
    "com.columbia": "Columbia",
    "ar.com.cuentadni": "Cuenta DNI",
    "app.ank": "Ank",
    "ar.com.reba": "Reba",
    "ar.com.modo": "MODO",
    "ar.com.claro": "Claro",
    "ar.com.moni": "Moni",
    "app.miiii": "Miiii",
    "ar.com.epagos": "E Pagos",
    "ar.com.uala": "Ualá",
    "com.resimple": "Re Simple",
    "ar.com.valepei": "Vale Pei",
    "com.pluspagos": "Plus Pagos",
    "com.auntap": "Tap",
    "ar.com.personalpay": "Personal Pay"
}

const pspDemo = {
    "0300": "ar.com.agilpagos",
    "0009": "com.mercadolibre",
    "0406": "ar.com.epagos",
    "0028": "ar.com.uala",
    "0070": "com.resimple",
    "0170": "com.auntap",
    "0314": "ar.com.personalpay",
    "0247": "ar.com.claro",
    "0254": "com.pluspagos",
    "0292": "ar.com.taca-taca",
}

const pspProd = {
    "0003": "com.mercadolibre",
    "0010": "app.miiii",
    "0029": "Nubi",
    "0034": "com.resimple",
    "0040": "com.auntap",
    "0072": "ar.com.moni",
    "0091": "ar.com.taca-taca",
    "0119": "ar.com.viumi",
    "0130": "ar.com.epagos",
    "0148": "ar.com.openpay",
    "0007": "ar.com.uala"
}

export {billeteras, pspDemo, pspProd};